import { SavedCustomField } from 'api/types';

// Formats a saved custom field's value for the read-only view, using the labels
// saved with the row so it never re-fetches the integration's options.
export const formatCustomFieldValue = (row: SavedCustomField): string => {
  const mapping = row.valueMapping;

  if (Array.isArray(mapping)) {
    return mapping
      .map((item) => item.label || item.value)
      .filter(Boolean)
      .join(', ');
  }

  if (typeof mapping === 'string') return mapping;
  return mapping?.label ?? (typeof mapping?.value === 'string' ? mapping.value : '');
};
